@let products = productsResource.error() ? [] : productsResource.value();

@if (products.length > 0) {
  @if (small()) {
    <mat-card class="cross-selling-card">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </mat-card>
  } @else {
    <ng-container *ngTemplateOutlet="content"></ng-container>
  }

}

<ng-template #content>
  @if (headline()) {
    @if (!small()) {
      <h3>{{ headline() }}</h3>
    } @else {
      <p>{{ headline() }}</p>
    }
  }

  @if (productsResource.isLoading()) {
    <ui-slider [navigation]="true" [spaceBetween]="24">
      @for (_ of skeletonArray; track $index) {
        @if (small()) {
          <ui-product-card-small-skeleton uiSliderSlide></ui-product-card-small-skeleton>
        } @else {
          <ui-product-card-skeleton uiSliderSlide></ui-product-card-skeleton>
        }
      }
    </ui-slider>
  } @else {
    <ui-product-slider
      [uiProductTrackingList]="trackingList"
      [small]="small()"
      [products]="products"
      [highlightedProducts]="[products[0]]"
      (addToShoppingList)="dialog.openDialogWithProduct($event.item, $event.quantity)"
    ></ui-product-slider>
  }
</ng-template>

<ui-add-to-shopping-list-dialog #dialog>
</ui-add-to-shopping-list-dialog>
